module.exports = __webpack_public_path__ + "img/gundula.d4d0eb02.jpg";